import { useParams } from "react-router-dom";

import { db } from "astrid-firebase";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import DropdownMenu from "../../ui/components/DropdownMenu/DropdownMenu";
import LoadingContext from "../../ui/components/LoadingContext/LoadingContext";
import PageView from "../../ui/views/PageView/PageView";

import CloudRunStatusLabel from "../../distribution/components/CloudRunStatus/CloudRunStatusLabel";
import PipelineStatusLabel from "../../distribution/components/DistributionStatus/PipelineStatusLabel";

import useExportDropdownMenuOptions from "../hooks/useExportDropdownMenuOptions";
import ExecutingExportPipelineView from "../views/ExecutingExportView/ExecutingExportPipelineView";

export default function ExportPipeline() {
	const params = useParams();

	const [theExport, loading, error] = useDocumentData(db.collection("exports").doc(params.export));

	const dropdownMenuOptions = useExportDropdownMenuOptions();

	return (
		<LoadingContext data={theExport} loading={loading} error={error}>
			<PageView
				header={theExport?.id}
				subheader={theExport?.name}
				extra={
					<>
						<PipelineStatusLabel distribution={theExport} />
						<CloudRunStatusLabel distribution={theExport} />
						<DropdownMenu options={dropdownMenuOptions(theExport)} />
					</>
				}
			>
				<ExecutingExportPipelineView theExport={theExport} />
			</PageView>
		</LoadingContext>
	);
}
